import D3 from './D3.container';

export default D3;
